<template>
  <div class="sys-ft">
    <div class="sys-main">
      <div class="sys-ft-info">
        <div class="sys-ft-intro sys-ft-intro-H5">
          <p>Copyright 2026 宙宇未来 All Rights Reserved</p>
        </div>
        <div class="sys-ft-left-wp">
          <div class="sys-ft-intro sys-ft-intro-PC">
            <img src="@/assets/images/logo.png" alt="" />
            <p>Copyright 2026 宙宇未来 All Rights Reserved</p>
          </div>
        </div>
        <div class="sys-ft-nav-wp">
          <dl>
            <dt>产品</dt>
            <dd>
              <a @click.prevent="getRouter('/#section2')">计算</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section2')">网络</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section2')">实时渲染</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section2')">存储</a>
            </dd>
          </dl>
          <dl>
            <dt>解决方案</dt>
            <dd>
              <a @click.prevent="getRouter('/#section1')">音视频解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section1')">云安全解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section1')">云游戏解决方案</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section1')">云渲染解决方案</a>
            </dd>
          </dl>
          <dl>
            <dt>品牌介绍</dt>
            <dd>
              <a @click.prevent="getRouter('/#section3')">关于我们</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section3')">联系我们</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section3')">加入我们</a>
            </dd>
          </dl>
          <dl>
            <dt>联系我们</dt>
            <dd>
              <a @click.prevent="getRouter('/#section3')">杭州宙宇未来科学技术有限公司</a>
            </dd>
            <dd>
              <a @click.prevent="getRouter('/#section3')">资源合作：400-679-9995</a>
            </dd>
          </dl>
        </div>
      </div>
      <div class="sys-ft-rights">
        <div style="text-align: center">
          <a href="#" class="first-beian">
            COPYRIGHT © 杭州宙宇未来科学技术有限公司 2026    浙ICP备2025174131号-1     增值电信业务经营许可证：B1-20253872
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useRouter } from "vue-router";
import { onMounted } from "vue";
import { useRouterStore } from "@/stores/router";
export default {
  name: "FooterIndex",
  setup() {
    const router = useRouter();
    const routerStore = useRouterStore();
    const { setRouterName } = routerStore;

    onMounted(() => {
      let dl = document.querySelectorAll(".sys-ft-nav-wp dl");
      for (let i = 0; i < dl.length; i++) {
        dl[i].onclick = function () {
          this.classList.toggle("sys-dl-show");
        };
      }
    });

    const getRouter = (path) => {
      // 处理带 hash 的路径，如 /#section3
      if (path.includes('#')) {
        const hash = path.substring(path.indexOf('#'));
        const basePath = path.substring(0, path.indexOf('#')) || '/';
        const currentPath = router.currentRoute.value.path;

        const scrollToEl = () => {
          const el = document.querySelector(hash);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        };

        if (currentPath === basePath) {
          scrollToEl();
        } else {
          setRouterName(basePath);
          router.push(basePath).then(() => {
            setTimeout(scrollToEl, 300);
          });
        }
      } else {
        setRouterName(path);
        router.push(path);
      }
    };
    return {
      router,
      routerStore,
      getRouter,
    };
  },
};
</script>

<style lang="scss">
.sys-ft {
  position: relative;
  color: #999;
  background: #222427;
  margin: 0 auto;
  min-width: 1200px;
  font-size: 14px;
  .sys-main {
    padding: 30px 20px 20px;
    box-sizing: border-box;
    position: relative;
    margin: 0 auto;
    // min-width: 1200px;
    .sys-ft-info {
      position: relative;
      border-bottom: 1px solid #444;
      padding-bottom: 48px;
      display: flex;
      justify-content: center;
      .sys-ft-intro {
        padding-right: 50px;
        h2 {
          font-weight: 600;
          font-size: 24px;
          display: inline-block;
          color: #fff;
        }
        p {
          font-size: 14px;
          color: #fff;
          margin-top: 8px;
        }
        a {
          width: 92px;
          height: 28px;
          display: inline-block;
          background: #fff;
          border-radius: 16px;
          font-size: 14px;
          color: #3b3f46;
          line-height: 24px;
          text-align: center;
          margin-top: 30px;
          text-decoration: none;
        }
        .btn-box {
          vertical-align: middle;
          box-sizing: border-box;
          padding: 1px 10px;
          border: 1px solid #fff;
          cursor: pointer;
        }
      }
      .sys-ft-intro-H5 {
        display: none;
      }
      .sys-ft-nav-wp {
        dl {
          display: inline-block;
          vertical-align: top;
          margin-left: 140px;
          line-height: 30px;
          dt {
            margin-bottom: 10px;
            font-size: 20px;
            color: #fff;
            font-weight: 600;
          }
          dd {
            font-size: 16px;
            a {
              outline: none;
              text-decoration: none;
              color: #999;
              cursor: pointer;
            }
          }
        }
      }
      .sys-ft-left-wp {
        display: flex;
        .sys-ft-intro {
          padding-right: 50px;
          img {
            width: 77px;
            height: 59px;
            display: inline-block;
          }
          h2 {
            font-weight: 600;
            font-size: 24px;
            display: inline-block;
            color: #fff;
          }
          p {
            margin-top: 35px;
            width: 198px;
            height: 42px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 600;
            font-size: 16px;
            color: #999999;
            text-align: left;
            font-style: normal;
            text-transform: none;
          }
          a {
            width: 92px;
            height: 28px;
            display: inline-block;
            background: #fff;
            border-radius: 16px;
            font-size: 14px;
            color: #3b3f46;
            line-height: 24px;
            text-align: center;
            margin-top: 30px;
          }
          a::after {
            display: inline-block;
            margin-left: 4px;
            width: 8px;
            height: 10px;
            background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAHAAAAADxpZzzAAABWElEQVQ4EZ2VLUgFQRSF198nIiIIikFEm4hWi1UwWK1Wg836iiabFm0Gk5gUi8HiKwaL4RVBsYho8Scogog/3wEHHsOd9c67cJjZc885zO4sM0VRFIegBgZBU/WN6wdcg9FmEmQOuGc+mRsSzGF8IWAmJ+QRcTCH8R1u3hsyjvDWCPmEW/SGDCO8NEL0gVe8If0Iz40Qvda6N6QH4UkiZAe+zRPUiWg/EXIAX/GEtCLaToScwvd6QqRZBWFrG8cL+AHgqmVUX6AxQPOsX3/TCFBIXe/qKe2OVa8WGXNrEPHy9fzvd9DqthLmGnzpTnQg2EuYj+C7QLK66RwDa9m78O0gWX10zoBl3oBvSTppDIE6sMzVMqN6Y+AGxGb9QEugtKboPoDY/AG3UOr8a+oMjM1vcLMeszSx+Qlu2muOA+4gJnLM0oaL5Yr5SK5ZR5QukmcwB3SxZNUv7JaVxV/xYZEAAAAASUVORK5CYII=)
              no-repeat 50% / 100% 100%;
            content: "";
          }
          .btn-box {
            border: 1px solid #fff;
            cursor: pointer;
            box-sizing: border-box;
            padding: 1px 10px;
            vertical-align: middle;
          }
        }

        .sys-ft-intro-PC {
          display: inline-block;
        }
        .sys-footer-codebox {
          font-size: 13px;
          margin-top: 10px;
          list-style: none;
          .codebox-PC {
            display: inline-block;
            vertical-align: top;
            box-sizing: border-box;
            margin-right: 20px;
            color: #999;
            text-align: center;
            img {
              margin: 0 auto 10px;
              width: 112px;
              height: 112px;
              display: block;
              border: 0;
            }
            p {
              width: 106px;
              height: 18px;
              background: #fff;
              border-radius: 9px;
              font-weight: 400;
              font-size: 12px;
              color: #181a1e;
              margin-left: 3px;
            }
          }
        }
        .sys-footer-codebox li:last-child {
          margin-right: 0;
        }
        .codebox-H5 {
          display: none;
          img {
            margin: 0 auto 10px;
            width: 112px;
            height: 112px;
          }
          p {
            width: 106px;
            height: 18px;
            background: #fff;
            border-radius: 9px;
            font-weight: 400;
            font-size: 12px;
            color: #181a1e;
            margin-left: 3px;
          }
        }
      }
    }
    // .sys-ft-info::after {
    //   position: absolute;
    //   left: 53%;
    //   top: 8px;
    //   bottom: 0;
    //   width: 1px;
    //   height: 144px;
    //   content: "";
    //   background-color: #444;
    // }
    .sys-ft-rights {
      margin-top: 25px;
      font-size: 12px;
      color: #71757b;
      display: flex;
      justify-content: center;
      a {
        text-decoration: none;
        color: #71757b;
        img {
          display: inline-block;
          height: 18px;
          width: 18px;
          vertical-align: text-top;
          margin-right: 3px;
        }
      }

      .first-beian {
        margin-right: 30px;
      }
      .last-beian {
        margin-left: 60px;
      }
      p {
        font-size: 12px;
      }
    }
  }
}
// 适配移动端
@media screen and (max-width: 768px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
      padding: 40px 20px;
      .sys-ft-info {
        position: relative;
        display: block;
        padding-bottom: 0px;
        margin: 0px -20px;
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
        .sys-ft-intro-H5 {
          display: inline-block;
          text-align: center;
          width: 100%;
          padding-right: 0px;
          .sys-ft-intro h2 {
            font-weight: 600;
            font-size: 24px;
            display: inline-block;
            color: rgb(255, 255, 255);
          }
        }
        .sys-ft-left-wp {
          display: block;
          .sys-ft-intro-PC {
            display: none;
          }
          .sys-footer-codebox {
            display: flex;
            position: static;
            text-align: center;
            width: 100%;
            margin: 30px auto 10px;
            font-size: 12px;
            padding-left: 20px;
            .codebox-PC {
              display: none;
            }
            .codebox-H5 {
              display: flex;
              background: #fff;
              margin-right: 20px;
              img {
                width: 100px;
                height: 100px;
                margin: 10px 5px;
              }
              p {
                line-height: 14px;
                width: 16px;
                height: 90px;
                background: #fff;
                color: #000;
                border-radius: 9px;
                font-weight: 400;
                font-size: 10px;
                margin-right: 8px;
                margin-top: 24px;
              }
              .codebox-H5-p-black {
                height: 90px;
                background: #000;
                color: #fff;
                margin-right: 4px;
                margin-top: 28px;
              }
            }
          }
        }
        .sys-ft-nav-wp {
          position: relative;
          top: 40px;
          padding-bottom: 40px;
          dl {
            position: relative;
            display: block;
            max-height: 50px;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            transition: max-height 2s;
            margin: 0;
            dt {
              position: relative;
              margin-bottom: 0;
              padding: 0 20px;
              font-size: 14px;
              color: #fff;
              font-weight: 600;
            }
            dt:after {
              position: absolute;
              bottom: 0;
              height: 1px;
              content: "";
              background: #cacdd0;
              transform: scaleY(0.5);
              transform-origin: center bottom;
              left: 20px;
              right: 20px;
              background-color: #41444a;
            }
            dd {
              padding: 0 20px;
              background-color: #333;
              font-size: 12px;
              margin: 0;
              a {
                color: #fff;
              }
            }
          }
          dl.sys-dl-show {
            height: auto;
            max-height: 600px;
          }
          dl:before {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
          }
          dl:after {
            position: absolute;
            right: 20px;
            top: 24px;
            width: 13px;
            height: 1px;
            content: "";
            background-color: #999;
            transform: rotate(90deg);
            transition: transform 0.3s, -webkit-transform 0.3s;
          }
        }
      }
      .sys-ft-info::after {
        display: none;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
    }
  }
}
@media screen and (max-width: 576px) {
  .sys-ft {
    min-width: 100%;
    .sys-main {
      width: 100%;
      .sys-ft-rights {
        div {
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
}
</style>